export const ru = {
    'empty-search-result-details': 'Убедитесь, что в запросе нет ошибок или попробуйте уменьшить длину запроса',
    'empty-search-result-title': 'Ничего не найдено',
    'no-variants': 'Нет вариантов для выбора',
    search: 'Поиск'
};
